export default {
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. responsive WordPress',
  show_category_in_selected_filters: true,
  categories_with_forced_search_page: ['template-kits', 'ui-templates'],
  noIndex: {
    routes: ['/attributes/:key/:value'],
    params: [{ name: 'compatible_with' }, { name: 'page' }]
  },
  features: {
    /**
     * @description Allows to set custom dimensions along with experiments events
     * @author Pawel Galazka
     * @expires When all phases of TF home redesign finishes (it should be enabled then permanently)
     */
    'experiment:dimensions': false
  }
}
